// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75fc48e6","455":"bdb94592","977":"71d2cce3"}[chunkId] + ".chunk.js";
};